import { cn } from '@/lib/utils';

export const paCardClass = 'rounded-[14px] border border-ink-150 bg-white-white px-[26px] pb-6 pt-[22px]';

export const paCardHeadClass = 'mb-3.5 flex items-start justify-between gap-3';

export const paCardTitleClass = 'text-base font-bold tracking-[-0.01em] text-ink-900';

export const paCardSubClass = 'mt-0.5 text-[12.5px] text-ink-500';

export const paChipClass =
  'relative inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-[10px] border border-ink-200 bg-white-white px-[11px] py-[7px] text-[12.5px] text-ink-700 hover:border-ar-blue';

export const paChipOpenClass = 'border-ar-blue shadow-[0_0_0_3px_var(--ar-blue-soft)]';

export const paChipDisabledClass = 'pointer-events-none cursor-not-allowed opacity-55';

export const paPopClass =
  'absolute left-0 top-[calc(100%+8px)] z-[100] m-0 list-none cursor-default rounded-[14px] border border-ink-200 bg-white-white p-0 text-left text-[13px] shadow-[0_18px_50px_rgba(11,23,51,0.18),0_4px_12px_rgba(11,23,51,0.08)]';

export const paPopNodeClass = 'flex cursor-pointer items-center gap-2 px-3.5 py-2 text-[13px] hover:bg-ink-50';

export const paPopNodeSelectedClass = 'bg-[#E8EFFF] text-white-white';

export const paPopBtnClass =
  'cursor-pointer rounded-lg border-0 bg-brand-600 px-3 py-1.5 text-[12.5px] text-white-white disabled:cursor-not-allowed disabled:bg-ink-200 disabled:text-ink-500';

export const paSegClass = 'inline-flex gap-0.5 rounded-[9px] bg-ink-100 p-[3px]';

export const paSegBtnClass = 'cursor-pointer rounded-md border-0 bg-transparent px-[11px] py-1.5 text-xs font-medium text-ink-600 hover:text-ink-900';

export const paSegBtnActiveClass = 'bg-white-white font-semibold text-ink-900 shadow-[0_1px_2px_rgba(0,0,0,0.06)]';

export const Card = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return <div className={cn(paCardClass, className)}>{children}</div>;
};

export const CardHead = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return <div className={cn(paCardHeadClass, className)}>{children}</div>;
};

export const CardTitle = ({ text, className }: { text: string; className?: string }) => {
  return <div className={cn(paCardTitleClass, className)}>{text}</div>;
};

export const CardSubtitle = ({ text, className }: { text: string; className?: string }) => {
  return <div className={cn(paCardSubClass, className)}>{text}</div>;
};
